import { cn } from '@/lib/cn'
import { initialsFor } from '@/lib/format'

/**
 * Företagets logga, eller dess initialer i klubbfärgerna när logga saknas.
 * Alla företag ska se ut att höra hemma i samma häfte även om bara hälften
 * skickat in en bild.
 */
export function CompanyAvatar({
  name,
  logoUrl,
  size = 56,
  className,
}: {
  name: string
  logoUrl?: string | null
  size?: number
  className?: string
}) {
  const base = cn(
    'flex shrink-0 items-center justify-center overflow-hidden rounded-2xl',
    'border border-border bg-surface',
    className,
  )

  if (logoUrl) {
    return (
      <div className={base} style={{ width: size, height: size }}>
        <img
          src={logoUrl}
          alt=""
          aria-hidden
          loading="lazy"
          className="h-full w-full object-contain p-1.5"
        />
      </div>
    )
  }

  // Dämpad med flit. Tolv mättade blå-gula rutor nedför en lista drar till
  // sig all uppmärksamhet och lämnar ingen kvar till rabatten, som är det
  // ögat faktiskt letar efter. En rad ska ha ett blickfång, inte två.
  return (
    <div
      className={cn(base, 'border-transparent bg-brand-soft')}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <span
        className="font-display font-extrabold text-brand-ink"
        style={{ fontSize: Math.round(size * 0.34) }}
      >
        {initialsFor(name)}
      </span>
    </div>
  )
}
